function base64ToBlob(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: "application/pdf" });
}

function escapeTitle(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function openPdfFromBase64(base64, title) {
  if (!base64) return;
  const pdfWindow = window.open("");
  if (!pdfWindow) return;
  const url = URL.createObjectURL(base64ToBlob(base64));
  pdfWindow.document.write(
    "<head><title>" +
      escapeTitle(title) +
      "</title></head><body style='margin:0'><iframe width='100%' height='100%' style='border:0;position:fixed;inset:0' src='" +
      url +
      "'></iframe></body>"
  );
  pdfWindow.document.close();
}
